module.exports = __webpack_public_path__ + "static/img/MineTopAvatar.dc83537.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/SdkV3/MineTopAvatar.png
// module id = t1Py
// module chunks = 39